module.exports = __webpack_public_path__ + "img/moon.c51b6163.png";